"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyHodOnboardingDataTypeId = exports.HodOnboardingDataTypeId = void 0;
const CommonOnboardingDataTypeId_1 = require("../../common/domain/CommonOnboardingDataTypeId");
var HodOnboardingDataTypeId;
(function (HodOnboardingDataTypeId) {
})(HodOnboardingDataTypeId = exports.HodOnboardingDataTypeId || (exports.HodOnboardingDataTypeId = {}));
exports.AnyHodOnboardingDataTypeId = Object.assign({}, CommonOnboardingDataTypeId_1.CommonOnboardingDataTypeId, HodOnboardingDataTypeId);
//# sourceMappingURL=HodOnboardingDataTypeId.js.map